import Vue from 'vue' 
import App from './App.vue'
import router from './router'
import store from './store/store.js'
import { get, post } from "./network/request" 
import Meta from 'vue-meta'
Vue.use(Meta)
Vue.prototype.$http = { 
  get,
  post
};
Vue.config.productionTip = false
Vue.filter('objs',(e) =>{
  if(e){
    return e.replace('http://obj','https://objs')
  }
  
})
new Vue({
  router, 
  store, 
  render: h => h(App)
}).$mount('#app')